import '../App.css'
import Footer from '../Footer'
import './Contact.css'
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

export const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
        .sendForm("service_1xv6vp8", 'template_l18l4ge', form.current, {
            publicKey: 'gYCNOKeFNZp8g_iGe',
        })
        .then(
            () => {
            console.log('SUCCESS!');
            },
            (error) => {
            console.log('FAILED...', error.text);
            },
        );
        e.target.reset();
    };
    return (
        <>
        <h1 className='contact'>Contact</h1>
        <div className='contact-section'>
            <div className='contact-info'>
                <i class="fa-solid fa-envelope"></i>
                <label className='contact-info-label'>
                    shawnmortgage6@gmail.com
                </label>
                <i class="fa-solid fa-phone"></i>
                <label className='contact-info-label'>
                    (416) 846-7035
                </label>
                <i class="fa-solid fa-location-pin"></i>
                <label className='contact-info-label'>
                    578 Upper James Street, Hamilton Ontario, L9C 2Y6
                </label>
            </div>
            <div className=''></div>
            <h1 className='contact-header'>
                Contact Us Now!
            </h1>
            <form className='contact-form' ref={form} onSubmit={sendEmail}>
                <label className='contact-label'>Name</label>
                <input className='user__name__input' type="text" name="from_name" placeholder='Name' />
                <label className='contact-label'>Email</label>
                <input className='user__email__input'  type="email" name="reply_to" placeholder='example@gmail.com' />
                <label className='contact-label'>Subject</label>
                <input className='user__subject__input' type="text" name="from_subject" placeholder='Buying a house' />
                <label className='contact-label'>Message</label>
                <textarea className='contact-messageArea' name="message" placeholder='Enter your message here' />
                <input className='contact-send' type="submit" value="Send" />
            </form>
        </div>
        <Footer/>
        </>
    );
};

// export default function Signup() {
//     return (
//         <>
//         <div>
//         <form className='contact-form' ref={form} onSubmit={sendEmail}>
//         <label>Name</label>
//         <input type="text" name="user_name" />
//         <label>Email</label>
//         <input type="email" name="user_email" />
//         <label>Message</label>
//         <textarea name="message" />
//         <input type="submit" value="Send" />
//         </form>
//         </div>    
        
//         </>  
//     ) 
// }